// extracted by mini-css-extract-plugin
module.exports = {"Content":"Content_Content__F0mP3","columnsContainer":"Content_columnsContainer__3xSt3"};